import RefinitivTheme from './refinitiv'

const getBaseTheme = ({ mode, ...rest }) => {
  let theme

  if (!mode) {
    throw new Error('You must provide a theme mode to the theme provider')
  }
  if (mode.toLowerCase() === 'refinitiv') {
    theme = RefinitivTheme
  } else {
    throw new Error(`Invalid Theme Mode Provided: ${mode}`)
  }

  return theme({ ...rest })
}

export default getBaseTheme
